"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FilterItemOptionStyled = require("./FilterItemOption-styled.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FilterItemOption = function FilterItemOption(_ref) {
  var _ref$itemOption = _ref.itemOption,
    id = _ref$itemOption.id,
    title = _ref$itemOption.title,
    state = _ref$itemOption.state,
    onFilterItemOptionClick = _ref.onFilterItemOptionClick;
  var active = state === _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE;
  var disabled = state === _stateTypes.default.FILTER_ITEM_OPTION_DISABLED;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FilterItemOptionStyled.StyledFilterItemOption, {
    active: active,
    disabled: disabled,
    onClick: function onClick() {
      return onFilterItemOptionClick && onFilterItemOptionClick(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_FilterItemOptionStyled.StyledListItemTitle, null, title)));
};
FilterItemOption.propTypes = {
  itemOption: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    state: _propTypes.default.string.isRequired
  }),
  onChangeFilter: _propTypes.default.func
};
var _default = FilterItemOption;
exports.default = _default;